<template>   
    <b-row class="slide-body bc-color main-row">

        <transition name="fade" mode="out-in">
            <router-view></router-view>
        </transition>
    
        <b-row class="timer-row bc-color-footer">
            <b-col cols="4" align-self="center">                               
            </b-col>
            <b-col cols="4">
                <app-timer :slide_redirect="redirect" timer_seconds="900" typeGame="game2" @sendTime="fCalculTime"></app-timer>
            </b-col>
            <b-col cols="4" align-self="center">   
                <b-button @click="modalEndChallengeShow=true" size="lg" variant="success"><h2><strong>{{ $t('slide22.text1') }}</strong></h2></b-button>

                <b-modal v-model="modalEndChallengeShow" :title="$t('slide22.text2')" 
                effect="fade/zoom" :ok-title="$t('slide22.text1')" 
                :cancel-title="$t('slide22.text5')" @ok="fEndChallenge">                   
                    <form role="form" method="post">
                        <div class="form-group">                           
                            <label><p>{{ $t('slide22.text3') }}</p></label> 
                            <label><p>{{ $t('slide22.text4') }}</p></label>                                                         
                        </div>
                    </form>
                </b-modal>                    
            </b-col>           
        </b-row>         
    </b-row>        
   
</template>

<script>
import {mapState} from 'vuex';
import Timer from './Timer.vue';

import {bus} from '../main';

export default {    
    data(){
        return {                
            modalEndChallengeShow: false,
            elapsedTimeGame2: 0,
            lang:'',
            redirect:''
        }
    },    
    computed: mapState(['showMenu']),
    components:{
        appTimer: Timer
    },
    methods:{
        fEndChallenge(){ 
            bus.$emit('getTime', true);            
            this.$store.dispatch('updateVariable',{name: 'elapsedTimeGame2',value: this.elapsedTimeGame2});
            this.$router.push("/slide23/"+this.lang); 
        },
        fCalculTime(result){
            this.elapsedTimeGame2 = result;
        },
    },
    beforeCreate(){
        this.$store.dispatch('changeShowMenu',true);        
    },
    created(){
        this.lang=this.$route.params.lang;
        this.$i18n.locale=this.lang;
        this.redirect = '/slide23/'+this.lang;
    }
}
</script>


<style scoped>

    .main-row{
        margin-left: 0px;
        margin-right: 0px;  
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .timer-row{
        width: 100%
    }
    
    .bc-color{
        background: #ffffff;
    }

    .bc-color-footer{
        background: #253789;
    }

</style>